/**
 * Tab patterns for horizontal page tabs and vertical settings tabs.
 * Universal tab components consume these.
 *
 * Token note (theme-bridge): tabs flow through `text-foreground` /
 * `text-muted-foreground` / `bg-muted` / `bg-card` so they render
 * correctly in both portal (light) and marketing (dark) themes.
 */

export const tabPatterns = {
  horizontal: {
    list: 'flex items-center gap-1 border-b border-border',
    trigger: 'px-4 py-2.5 text-sm font-medium text-muted-foreground border-b-2 border-transparent hover:text-foreground',
    triggerActive: 'px-4 py-2.5 text-sm font-semibold text-foreground border-b-2 border-primary',
    content: 'pt-6',
  },
  vertical: {
    wrapper: 'flex gap-8',
    list: 'w-56 shrink-0 space-y-1',
    trigger: 'flex w-full items-center gap-3 rounded-sm px-3 py-2 text-sm text-muted-foreground hover:bg-muted hover:text-foreground',
    triggerActive: 'flex w-full items-center gap-3 rounded-sm bg-primary/10 px-3 py-2 text-sm font-medium text-primary',
    content: 'flex-1 space-y-6',
  },
  pill: {
    list: 'inline-flex items-center gap-1 rounded bg-muted p-1',
    trigger: 'rounded-sm px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground',
    triggerActive: 'rounded-sm bg-card px-3 py-1.5 text-sm font-medium text-foreground shadow-card',
  },
} as const;
